export const ONE_DAY = 1000 * 60 * 60 * 24
